import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ApiAdapter } from 'infrastructure/common/api.adpater';
import { UserContactCompanyOutput } from 'user/model/contact/user-contact-company.output';
import { UserContactCompanyApiPort } from 'user/port/contact/user-contact-company-api.port';
import { UserSessionPort } from 'user/port/user-session.port';
import { FetchUserContactCompaniesApiQuery } from 'user/query/contact/fetch-user-contact-companies.query';

@Injectable()
export class UserContactCompanyApiAdapter
	extends ApiAdapter
	implements UserContactCompanyApiPort
{
	constructor(
		userSessionPort: UserSessionPort,
		translateService: TranslateService,
		private _fetchUserContactCompaniesApiQuery: FetchUserContactCompaniesApiQuery
	) {
		super(userSessionPort, translateService);
	}

	public fetchUserContactCompanies(): Observable<UserContactCompanyOutput[]> {
		return this.fetch$(this._fetchUserContactCompaniesApiQuery);
	}
}
